import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { RedeemCodeDetail } from './RedeemCodeDetail';
import { RedeemCodeTemplateListForm } from './RedeemCodeTemplateList';

export const RedeemCodeTemplate = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list/:id/codes`} component={RedeemCodeDetail} />;
    <Route path={`${props.match.path}/templatelist`} component={RedeemCodeTemplateListForm} />;
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/redeemCode/RedeemCodeTemplate.tsx